import React from 'react';
import styled from 'styled-components';
import { rhythm } from 'Themes/typography';
import { Input, FormControl, Grid } from '@material-ui/core';
import { takeInitials } from 'Utils';
import FieldError from '../components/FieldError';
import New from 'Images/new.svg';
import moment2 from 'moment';
import moment from 'moment-timezone';
import AvatarUser from '../AvatarUser';

const Container = styled.div`
  border-top: ${({ shortlisted }) =>
    !shortlisted ? '2px solid #999a9a' : '0'};
  padding: ${rhythm(0.3)} 0;
  position: relative;
  height: 100%;
`;

const Heading = styled.h1`
  font-size: 1rem;
`;

const InnerContainer = styled.div``;

const OldNotes = styled.div`
  padding-bottom: ${rhythm(0.3)};
`;

const ReqInput = styled(Input)`
  &&&:before {
    border-bottom: 1px solid rgba(255, 0, 0, 0.42);
  }
  &&&:after {
    border-bottom: 2px solid rgba(255, 0, 0, 0.42);
  }
  &&&:hover:before {
    border-bottom: 2px solid rgba(255, 0, 0) !important;
  }
`;

const ReqText = styled.span`
  color: rgba(255, 0, 0, 0.42);
`;

const Msg = styled.div`
  max-width: 70%;
  margin-left: ${({ name, creatorName }) =>
    name !== creatorName ? 'auto' : '0'};
  margin-right: ${({ name, creatorName }) =>
    name !== creatorName ? '0' : 'auto'};
  align-items: flex-start;
  justify-content: ${({ name, creatorName }) =>
    name !== creatorName ? ' flex-end' : 'flex-start'};
  display: flex;
  margin-bottom: 6px;
`;

const MsgAndTime = styled.div`
  margin: ${({ name, creatorName }) =>
    name !== creatorName ? '0 5px 0 0' : '0 0 0 5px'};
`;

const Text = styled.div`
  padding: 5px;
  background-color: ${({ name, creatorName }) =>
    name !== creatorName ? '#ffca28' : '#bdbdbd'};
  text-align: ${({ name, creatorName }) =>
    name !== creatorName ? 'right' : 'left'};
  border-radius: 4px;
`;

const Time = styled.div`
  font-size: 14px;
  text-align: ${({ name, creatorName }) =>
    name !== creatorName ? 'right' : 'left'};
`;

var prevName = 'something';
var showAvatar = true;
const renderChat = (note, isUpdated) => {
  const twoMsg = '_#%_';
  const timeToName = '_#?_';
  const nameToMsg = '_#$_';
  let result = [];
  if (note) {
    let msgs = note.split(twoMsg);
    for (var i = 0; i < msgs.length; i++) {
      let el = msgs[i];
      let time = el.split(timeToName)[0];
      let rest = el.split(timeToName)[1];
      let name = rest.split(nameToMsg)[0];
      let text = rest.split(nameToMsg)[1];

      var timeToLocal = moment
        .utc(time)
        .local()
        .format("'" + 'YY-MMM-DD HH:mm');
      let msgObj = {
        time: timeToLocal,
        name: name,
        text: text,
      };
      result.push(msgObj);
    }
  }
  return result;
};

const Correspondence = ({
  onUrlAndNoteChange,
  note,
  noteError,
  urlError,
  url,
  isTicketExpired,
  shortlisted,
  notes,
  details,
  notesGeneral,
  isUpdated,
  slipCreator,
  isSlipDiscarded,
}) => (
  <Container shortlisted={shortlisted}>
    <Heading>
      <div>Correspondence</div>
    </Heading>
    <OldNotes>
      {renderChat(notes, isUpdated).map((el, index) => {
        if (index === 0) {
          prevName = 'showFirstElBug';
        }
        if (prevName !== el.name) {
          showAvatar = true;
          prevName = el.name;
        } else {
          showAvatar = false;
        }
        prevName = el.name;
        return (
          <Msg name={el.name} creatorName={slipCreator.createdBy} key={index}>
            {el.name === slipCreator.createdBy ? (
              <AvatarUser showAvatar={showAvatar} user={el.name} />
            ) : null}
            <MsgAndTime
              name={el.name}
              creatorName={slipCreator.createdBy}
              index={index}
            >
              <Text name={el.name} creatorName={slipCreator.createdBy}>
                {decodeURI(el.text)}
              </Text>
              <Time name={el.name} creatorName={slipCreator.createdBy}>
                {el.time}
              </Time>
            </MsgAndTime>
            {el.name !== slipCreator.createdBy ? (
              <AvatarUser showAvatar={showAvatar} user={el.name} />
            ) : null}
          </Msg>
        );
      })}
    </OldNotes>
    <InnerContainer>
      <FormControl fullWidth>
        <Heading>
          Respond to specifier
          {!shortlisted ? <ReqText>*</ReqText> : null}
        </Heading>
        {noteError && <FieldError>{noteError}</FieldError>}
        {!shortlisted ? (
          <ReqInput
            multiline
            rowsMax={4}
            scroll="body"
            onChange={onUrlAndNoteChange('slipNote')}
            value={note}
            fullWidth
            placeholder="Add response"
            disabled={isSlipDiscarded}
          />
        ) : (
          <Input
            multiline
            rowsMax={4}
            scroll="body"
            onChange={onUrlAndNoteChange('slipNote')}
            value={note}
            fullWidth
            placeholder="Add response"
            disabled={isSlipDiscarded}
          />
        )}
      </FormControl>
    </InnerContainer>
  </Container>
);

export default Correspondence;
